export default __webpack_public_path__ + "static/cruiselines-royal-activities-2-b46e17afbcfbbe2160920b24645095ce.jpg";